import { ListReducer, mergeEntities } from '../../store';
import { transformNavigationNotifications } from './notification.transformers';
import { NewsfeedApiResponse } from './api.model';

export const navigationNotificationsReducer: ListReducer<
  'navigationNotifications'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationNotifications'
      ) {
        const data: NewsfeedApiResponse = action.payload.data;
        const ref = action.payload.ref;
        return mergeEntities<'navigationNotifications'>(
          state,
          transformNavigationNotifications(
            data.hits.hits.map(hit => hit._source),
          ),
          ref,
        );
      }
      return state;
    case 'WS_MESSAGE':
      const userId = action.payload.userId;
      switch (action.payload.type) {
        case 'award':
        case 'bid':
        case 'contestAwardedToEmployer':
        case 'contestEntry':
        case 'contestPCBNotification':
        case 'draftContest':
          return mergeEntities<
            'navigationNotifications'
          >(state, transformNavigationNotifications([action.payload]), {
            path: ['navigationNotifications', userId],
          });

        // I'm not sure if the newsfeed has these types. If they are possible then they should be added to NewsfeedApiResponseEntry.
        case 'awardBadge':
        case 'awardCredit':
        case 'awardMilestoneReminder':
        case 'awardReminder':
        case 'awardXp':
        case 'completed':
        case 'contactRequestReceived':
        case 'contest':
        case 'contestAwardedToFreelancer':
        case 'contestEntryBoughtToEmployer':
        case 'contestEntryBoughtToFreelancer':
        case 'contestPCBNotificationFullView':
        case 'createMilestone':
        case 'denyed':
        case 'failingProject':
        case 'highLtvAnnualDiscount':
        case 'inviteToContest':
        case 'inviteUserBid':
        case 'invoiceRequested':
        case 'levelup':
        case 'notifyfollower':
        case 'project':
        case 'projectRecruiter':
        case 'quickHireProject':
        case 'releaseMilestone':
        case 'requestEndProject':
        case 'requestMilestone':
        case 'requestToRelease':
        case 'serviceApproved':
        case 'serviceProjectEndingSeller':
        case 'serviceProjectPostedSeller':
        case 'serviceRejected':
        case 'signUpFreeTrialUpsell':
        case 'sitesBinCreated':
        case 'sitesHandOverMessageSent':
        case 'sitesListingStatusChanged':
        case 'sitesMessageSent':
        case 'sitesOfferCreated':
        case 'upsellCrowdsourceFinding':
        case 'xpContest':
          return state;
        default:
          return state;
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/navigation/notifications/notifications.reducer.ts